module.exports = __webpack_public_path__ + "static/media/regulativa.7d7e41ae.svg";